export default __webpack_public_path__ + "static/media/palm-bnb.8d44bd37.png";